import Main from 'components/Main';

import './index.less';
import './themes/default.less';

import CheckBox from "components/CheckBox";

export default class General extends Main {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            odessShow: false,
        };
    }

    render() {
        const { odessShow } = this.state;
        return (
            <div className="general flex flex1 gap16">
                <div className="text p1">
                    <CheckBox
                        ref={el => this.check = el}
                        checked={odessShow}
                        title="Отобразить клинику Одесская"
                        onClick={this.toggleState.bind(this, "odessShow")} />; 
                </div>
            </div >
        );
    }
}
